// extracted by mini-css-extract-plugin
module.exports = {"processResultAlert":"ProcessResultAlert_processResultAlert__FTWy7","success":"ProcessResultAlert_success__qF5Mu","fail":"ProcessResultAlert_fail__sLPSb"};